import { ReactNode } from 'react'
import HomepageHeader from 'shared/components/homepage-section-header'
import VideoScrollCarousel from 'shared/components/video-preview-thumbnail/scroll-carousel/trending'
import styled from 'styled-components'

const Container = styled.div`
    margin-bottom: 20px;
`
type Props = {
    icon?: ReactNode
}

const TodaysVideos = ({ icon }: Props) => {
    return (
        <Container>
            <HomepageHeader label="Clips" seeAllLabel={`All Clips`} icon={icon} url="/clips" />
            <VideoScrollCarousel width={160} previewLabelPadding={6} />
        </Container>
    )
}

export default TodaysVideos
